// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';
import { MrAppLayout, MrHeaderTabs, MrTab, MrTabList, MrTabPanel } from '@ion/components';
import MrTabPanelBase from 'app/components/MrTabPanelBase';
import SideNav from 'app/components/side-nav';
import Header from 'app/components/app-header';
import ClustersTab from './ClustersTab';
import TransformationLibTab from 'app/clusters/TransformationLibTab';

function ClustersPage() {
  return (
    <MrAppLayout
      title="Clusters"
      description="Manage your clusters."
      sideNav={<SideNav />}
      header={<Header icon="clusters" title="Clusters" />}
    >
      <MrHeaderTabs>
        <MrTabList>
          <MrTab>Transformation Library</MrTab>
          <MrTab data-test-id="clusters-tab">Clusters</MrTab>
        </MrTabList>

        <MrTabPanel>
          <MrTabPanelBase>
            <TransformationLibTab />
          </MrTabPanelBase>
        </MrTabPanel>
        <MrTabPanel>
          <MrTabPanelBase>
            <ClustersTab />
          </MrTabPanelBase>
        </MrTabPanel>
      </MrHeaderTabs>
    </MrAppLayout>
  );
}

export default ClustersPage;
